import { gql, useMutation } from '@apollo/client';
import { useState } from 'react';
import {
  MutationGenerateSigninOtpArgs,
  OtpTypeEnum,
} from '@updater/consumer-graph/generated/graphql';

const GENERATE_SIGNIN_OTP = gql`
  mutation GenerateSigninOtp($input: GenerateSigninOtpInput!) {
    generateSigninOtp(input: $input)
  }
`;

export function useGenerateSigninOtp() {
  const [error, setError] = useState<string | null>(null);
  const [resendLoading, setResendLoading] = useState(false);

  const [generateSigninOtp] = useMutation<
    { generateSigninOtp: boolean },
    MutationGenerateSigninOtpArgs
  >(GENERATE_SIGNIN_OTP);

  const generate = async (
    email: string,
    otpType: OtpTypeEnum
  ): Promise<boolean> => {
    setError(null);
    try {
      const result = await generateSigninOtp({
        variables: { input: { email, otpType } },
      });
      if (result.errors?.length) {
        setError(result.errors[0].message);
        return false;
      }
      if (!result.data?.generateSigninOtp) {
        setError('Failed to send verification code. Please try again.');
        return false;
      }
      return true;
    } catch (err) {
      setError(
        err instanceof Error
          ? err.message
          : 'Failed to send verification code. Please try again.'
      );
      return false;
    }
  };

  const resend = async (
    email: string,
    otpType: OtpTypeEnum
  ): Promise<boolean> => {
    if (resendLoading) return false;
    setResendLoading(true);
    const success = await generate(email, otpType);
    setResendLoading(false);
    return success;
  };

  const reset = () => {
    setError(null);
  };

  return { generate, resend, reset, error, resendLoading };
}
